import { Login } from "./login/login";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { HiOutlineUsers } from "react-icons/hi2";
import { IoHomeOutline, IoSearch } from "react-icons/io5";
import { FaEarthAmericas } from "react-icons/fa6";
import { FiPlusCircle } from "react-icons/fi";
import Context from "../utils/context";
import { IoIosClose } from "react-icons/io";
import { environment } from "../../env";
import NotificationIcon from "./NotificationIcon";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const context = useContext(Context);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const gotToFeatures= () => {
    if (!context.homepageSections.features) {
      navigate("/");
    } else {
      context.homepageSections.features.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const gotToUseCases = () => {
    if (!context.homepageSections.useCases) {
      navigate("/");
    } else {
      context.homepageSections.useCases.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const gotToAdvantages = () => {
    if (!context.homepageSections.advantages) {
      navigate("/");
    } else {
      context.homepageSections.advantages.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const gotToContact = () => {
    if (!context.homepageSections.contact) {
      navigate("/");
    } else {
      context.homepageSections.contact.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <nav className={`bg-primary p-4 shadow-md ${context.account.userId === undefined && 'fixed w-full z-50'}`}>
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <NavLink
          to="/"
          className="flex items-center text-white text-xl font-bold"
        >
          <img
            src={`${environment.PUBLIC_URL}/img/Found.svg`}
            alt="logo"
            className="h-8"
          />
          <img
            src={`${environment.PUBLIC_URL}/img/Vector.svg`}
            alt="logo"
            className="h-8"
          />
        </NavLink>

        {/* Hamburger Icon (Visible on smaller screens) */}
        <div className="md:hidden" onClick={toggleMenu}>
          <svg
            className="h-6 w-6 cursor-pointer text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </div>

        {/* Nav Links (Hidden on smaller screens) */}
        <div
          className={`nav-menu z-50 md:z-auto bg-primary md:bg-none place-content-center fixed md:relative top-0 right-0 p-5 md:p-0 h-full w-3/5 md:flex md:items-center md:space-x-6 block ${
            isMenuOpen ? "open" : "closed"
          }`}
        >
          <ul className="flex flex-col md:flex-row md:space-x-6 text-white font-sans text-2xl md:text-base">
            <li
              className="md:hidden absolute top-0 right-0 cursor-pointer"
              onClick={toggleMenu}
            >
              <IoIosClose size={44} />
            </li>
            <UnauthenticatedTemplate>
              <li>
                <span
                  onClick={gotToFeatures}
                  className="text-white cursor-pointer hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <span className="ms-2">Features</span>
                </span>
              </li>
              <li>
                <span
                  onClick={gotToUseCases}
                  className="text-white cursor-pointer hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <span className="ms-2">Use Cases</span>
                </span>
              </li>
              <li>
                <span
                  onClick={gotToAdvantages}
                  className="text-white cursor-pointer hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <span className="ms-2">Advantages</span>
                </span>
              </li>
              <li>
                <span
                  onClick={gotToContact}
                  className="text-white cursor-pointer hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <span className="ms-2">Contact</span>
                </span>
              </li>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
              <li>
                <NavLink
                  to="/"
                  className="text-white hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <IoHomeOutline size={20} className="mt-1 md:mt-0" />
                  <span className="ms-2">Home</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/earthtwin2"
                  className="text-white hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <FaEarthAmericas size={20} className="mt-1 md:mt-0" />
                  <span className="ms-2">Earth Twin</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/posts/create"
                  className="text-white hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <FiPlusCircle size={22} className="mt-1 md:mt-0" />
                  <span className="ms-2">Create</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contacts"
                  className="text-white hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <HiOutlineUsers size={22} className="mt-1 md:mt-0" />
                  <span className="ms-2">Contacts</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/search"
                  className="text-white hover:text-text-link py-2 me-5 md:py-0 inline-flex"
                >
                  <IoSearch size={22} className="mt-1 md:mt-0" />
                  <span className="ms-2">Search</span>
                </NavLink>
              </li>
            </AuthenticatedTemplate>
          </ul>
        </div>
        <div
          className="text-white cursor-pointer flex justify-between mt-4 md:mt-0"
          style={{
            display: `${context.notificationCount > 0 ? "flex" : "none"}`,
          }}
          onClick={() => {
            navigate("contacts/notifications");
          }}
        >
          <NotificationIcon count={context.notificationCount} />
        </div>
        {/* Buttons */}
        <div
          className="flex justify-center md:justify-end space-x-4 font-sans mt-4 md:mt-0"
          onClick={toggleMenu}
        >
          <Login />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
